const locale = require('./proposalQuotableProductModal.i18n.json');

/*@ngInject*/
const ProposalQuotableProductController = function ($rootScope, $scope, options, coreConstant) {

    $scope.i18n = locale;
    $scope.selectedProduct = _.get($scope.i18n, 'prompt');
    $scope.cancelButton = _.get($scope.i18n, 'cancel');
    $scope.okButton = _.get($scope.i18n, 'createQuote');
    $scope.title = _.get($scope.i18n, 'title');
    $scope.selectedQuotableProduct = null;
    $scope.quotableProducts = _.groupBy(options.quotableProducts, 'grouping');

    $scope.showCheckMark = function () {
        return !_.isNil($scope.selectedQuotableProductId);
    };

    $scope.canEnableConfirmButton = function () {
        return $scope.selectedQuotableProductId !== null;
    };

    $scope.onConfirm = function () {
        $scope.$close({
            submissionId : _.split($scope.selectedQuotableProduct.value, '::')[0],
            selectedQuotableProductId : $scope.selectedQuotableProductId
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.handleClick = function (quotableProduct) {
        $scope.selectedQuotableProduct = quotableProduct;
        $scope.selectedProduct = quotableProduct.name;
        $scope.selectedQuotableProductId = _.split($scope.selectedQuotableProduct.value, '::')[1];
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('proposalQuotableProductController', ProposalQuotableProductController);
